import React, { useEffect, useState } from 'react';
import { headerDataImmo } from '../../data/modules/logistic-header';
import MainContainer from '../../components/MainContainer';
import { Paper, AppBar, Grid, Box, FormControl, Button, TextField, Select, MenuItem } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { AntTab, AntTabs } from '../../components/ant-tab';
import Spacer from '../../components/Spacer';
import { Autocomplete } from '@mui/material';
import MissionOrderService from '../../services/MissionOrderService';
import VehicleService from '../../services/VehicleService';
import Message from '../tools/Message';
import { useNavigate, useParams } from 'react-router';
import DirectionService from '../../services/DirectionService';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    elevation: 2,
    borderRadius: "8px !important",
    marginTop: "1.5%",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
    width: "80%",
  },
  tab: {
    width: "50%",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
    width: "80%",
  },
}));

const bullRed = (
  <Box
    component="span"
    sx={{
      display: "inline-block",
      mx: "5px",
      transform: "scale(0.8)",
      color: "red",
      fontSize: "20px",
    }}
  >
    *
  </Box>
);

const VehicleAdd = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {id} = useParams();
  const [value, setValue] = useState(0);
  const [drivers, setDrivers] = useState([]);
  const [directions, setDirections] = useState([]);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const [directionId, setDirectionId] = useState(0);
  const [formValues, setFormValues] = useState({
    id: null,
    immatriculation: "",
    type: "FID",
    driver: "",
    mark: "",
    nombrePlace: "",
    sourceEnergie: "",
    description: "",
    direction: "",
    conso100km: "",
    rental_start_date: "",
    rental_end_date: "",
    driver_contact: "",
    driver_name: "",
  });
  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  useEffect(() => {

    async function fetchDirections() {
      setOpenLoadingSimpleBackdrop(true);
      try {
          DirectionService.getDirection().then((result) => {
              if (result && result.data) {
                setDirections(result.data);
              }
            });
          } catch (error) {
            console.error("Error fetching directions:", error);
          } finally {
            setOpenLoadingSimpleBackdrop(false);
          }
        }

    fetchDirections();
  }, []);

  useEffect(() => {
    async function fetchDrivers(direction_id) {
      setOpenLoadingSimpleBackdrop(true);
      try {
        const result = await VehicleService.getDriversMission(direction_id);
        if (result?.data) {
          setDrivers(result.data);
        }
      } catch (error) {
        console.error("Error fetching drivers:", error);
      } finally {
        setOpenLoadingSimpleBackdrop(false);
      }
    }
    if(directionId && directionId !== null){
    fetchDrivers(directionId);}
  }, [directionId]);

  useEffect(() => {
    async function fetchVehicle(vehicleId) {
      if (!vehicleId) return;  

      try {
        const result = await VehicleService.getVehicle(vehicleId);
        if (result?.data) {
          const vehicle = result.data;
         setFormValues({
          id: vehicle.vhc_id,
          immatriculation: vehicle.vhc_imm,
          type: vehicle.vhc_type,
          driver: vehicle.vhc_type === 'FID' ? drivers.find((driver) => driver.user_id === vehicle.driver_id) : { driver_name: vehicle.vhc_driver_name ?? "", driver_contact: vehicle.vhc_driver_contact ?? "" },
          mark: vehicle.vhc_mark,
          nombrePlace: vehicle.vhc_place,
          sourceEnergie: vehicle.vhc_energy,
          description: vehicle.vhc_description,
          direction: directions.find((direction) => direction.direction_id === vehicle.direction_id),
          conso100km: vehicle.vhc_conso_100km,
          rental_start_date: vehicle.rental_start_date || "",
          rental_end_date: vehicle.rental_end_date || "",
         })

         setDirectionId(vehicle.direction_id);
        }
      } catch (err) {
        console.error("Erreur lors de la récupération du véhicule :", err);
      }
    }
  
    fetchVehicle(id);  
  }, [id, directions, drivers]); 
  

  const updateFormValues = (updateFn) => {
    setFormValues((prev) => updateFn(prev));
  };
  
  const handleChange = (event, newValue) => {
    event.preventDefault();
    const { name, value } = event.target;
  
    updateFormValues((prev) => {
      if (name === "driver_name" || name === "driver_contact") {
        return {
          ...prev,
          driver: {
            ...prev.driver,
            [name]: value,
          },
        };
      }
  
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  
  const handleChangeAutocomplete = (event, name, value) => {
    event.preventDefault();
  
    updateFormValues((prev) => {
      if (name === "type" && value === "Location") {
        return {
          ...prev,
          [name]: value,
          driver: {
            driver_name: "",
            driver_contact: "",
          },
        };
      }
       if (name === "type" && value === "FID") {
        return {
          ...prev,
          [name]: value,
          driver: "",
        };
      }
      if(name === "direction"){
        setDirectionId(value.direction_id);
      }
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  

  const handleSubmit = () => {
    if(!formValues.type || !formValues.direction || !formValues.conso100km) {
      setMessage({ open: true, color: 'red', messageInfo: 'Veuillez remplir tous les champs obligatoires' });
      return;
    }

    if(formValues.type === "Location" && (!formValues.rental_start_date || !formValues.rental_end_date)) {
      setMessage({ open: true, color: 'red', messageInfo: 'Veuillez remplir les dates de location' });
      return;
    }
   
    try {
      VehicleService.saveVehivle(formValues).then((result) => {
        if (result.status) {
          setMessage({ open: true, color: 'green', messageInfo: 'Vehicle saved successfully' });
          navigate("/Logistic/mission/vehicle");
        }
      }
      );
      
    }
    catch (error) {
      setMessage({ open: true, color: 'red', messageInfo: error.message });
      console.error("Error saving vehicle :", error);

    } 
  }

  const handleCancel = () => {
    navigate("/Logistic/mission/vehicle");
  }

  return (
    <React.Fragment>
      <MainContainer {...headerDataImmo}>
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />      

        <AppBar position="static" color="default" className={classes.AppBar}>
          <AntTabs
            value={value}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <AntTab label="Information Voiture" id="scrollable-auto-tab-0" aria-controls="scrollable-auto-tabpanel-0" />

          </AntTabs>
        </AppBar>

        <Paper className={classes.paper} >
          {
            value === 0 && (
              <Box display="flex" flexDirection="column" sx={{ margin: 0.5 }}>

                <Paper variant="outlined">
                  <Box display="flex" flexDirection="column" sx={{ margin: "2%" }}>
                    <Grid container spacing={3} sx={{ m: 4 }}>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                          Immatriculation 
                        </label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            label="Immatriculation"
                            variant="outlined"
                            onChange={handleChange}
                            name="immatriculation"
                            value={formValues.immatriculation}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                          Type {bullRed}
                        </label>
                      </Grid>

                      <Grid item xs={8}>
                        <FormControl fullWidth size="small">
                          <Autocomplete id="tags-outlined"
                            options={["FID", "Location"]}
                            getOptionLabel={(option) => (option ? option.toString() : '')}
                            filterSelectedOptions
                           onChange={(event, value) => handleChangeAutocomplete(event, "type", value)}
                            value={formValues.type}
                            name={"type"}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                id="outlined-basic"
                                size="small"
                                variant="outlined"
                                label="Type"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                       {
                              formValues.type === "Location" ? (
                           <>               
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                          Date de début de location {bullRed}
                        </label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            onChange={handleChange}
                            label="Date de début de location"
                            name="rental_start_date"
                            type="date"
                            value={formValues.rental_start_date}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                          Date de fin de location {bullRed}
                        </label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            onChange={handleChange}
                            label="Date de fin de location"
                            name="rental_end_date"
                            type="date"
                            value={formValues.rental_end_date}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </FormControl>
                      </Grid>
                      </> 
                              ) : null
                }
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>Direction {bullRed}</label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth size="small">
                        <Autocomplete id="tags-outlined"
                            options={directions}
                            getOptionLabel={(option) => (option ?  option?.name + '('+ option?.code + ')' : '')}
                            filterSelectedOptions
                            onChange={(event, value) => handleChangeAutocomplete(event, "direction", value)}
                            value={formValues.direction}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                id="outlined-basic"
                                size="small"
                                variant="outlined"
                                label="Direction"
                              />
                            )}
                          />
                       
                        </FormControl>
                      </Grid>
                            {
                              formValues.type === "FID" ? (
                           <>                    
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>Chauffeur {bullRed}</label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth size="small">
                          <Autocomplete id="tags-outlined"
                            options={drivers}
                            getOptionLabel={(option) => (option ? option?.name.toString() : '')}
                            filterSelectedOptions
                            onChange={(event, value) => handleChangeAutocomplete(event, "driver", value)}
                            value={formValues.driver || ''}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                id="outlined-basic"
                                size="small"
                                variant="outlined"
                                label="Chauffeur"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      </>
                      ) : (
                        <>
                        <Grid item xs={3}>
                          <label className={classes.labelPosition}>Nom du chauffeur / Prestataire </label>
                        </Grid>
                        <Grid item xs={8}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <TextField
                              fullWidth
                              id="outlined-basic"
                              size="small"
                              label="Nom du chauffeur / Prestataire"
                              variant="outlined"
                              onChange={handleChange}
                              name="driver_name"
                              value={formValues.driver_name}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <label className={classes.labelPosition}>Contact du chauffeur / Prestataire </label>
                        </Grid>
                        <Grid item xs={8}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <TextField
                              fullWidth
                              id="outlined-basic"
                              size="small"
                              label="Contact du chauffeur / Prestataire"
                              variant="outlined"
                              onChange={handleChange}
                              
                              name="driver_contact"
                              value={formValues.driver_contact}
                            />
                          </FormControl>
                        </Grid>
                        </>
                      )
                      }
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                          Source d'énergie 
                        </label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth variant="outlined" size="small">
                        <Autocomplete id="tags-outlined"
                            options={["Essence", "Diesel"]}
                            getOptionLabel={(option) => (option ? option.toString() : '')}
                            filterSelectedOptions
                           onChange={(event, value) => handleChangeAutocomplete(event, "sourceEnergie", value)}
                            value={formValues.sourceEnergie}
                            name={"sourceEnergie"}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                id="outlined-basic"
                                size="small"
                                variant="outlined"
                                label="Source d'énergie"
                              />
                            )}
                          />
                        
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                        Consommation (L/100 km) {bullRed}
                        </label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth variant="outlined" size="small">
                        <TextField
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            onChange={handleChange}
                            label="consommation  par 100 km"
                            name="conso100km"  
                            type='number'
                            inputProps={{ step: "0.1" }}
                            value={formValues.conso100km}
                          />
                          </FormControl>
                          </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                          Marque 
                        </label>
                      </Grid>
                      <Grid item xs={8}>
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          onChange={handleChange}
                          label="Marque"
                          name="mark"
                          InputProps={{
                            style: { textTransform: "uppercase" },
                          }}
                          value={formValues.mark.toUpperCase()}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                          Nombre des places 
                        </label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            onChange={handleChange}
                            label="Nombre des places"
                            name="nombrePlace"  
                            type='number'
                            value={formValues.nombrePlace}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={3}>
                        <label className={classes.labelPosition}>
                          Description
                        </label>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl fullWidth variant="outlined" size="small">

                          <TextField
                            fullWidth
                            id="outlined-basic"
                            size="small"
                            multiline
                            label="Descripiton"
                            variant="outlined"
                            onChange={handleChange}
                            name="description"
                            height="500px"
                            value={formValues.description}
                          />
                        </FormControl>
                        <Spacer y={4} />

                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.text}>
                          ({bullRed}) : Champs obligatoire
                        </label>
                      </Grid>
                      <Grid container item xs={6} spacing={2} justifyContent="flex-end" sx={{ marginTop: 2 }}>


                        <Button
                          variant="contained"
                          color="secondary"
                          style={{ marginBottom: "40px", marginRight: '30px', }}
                          onClick={handleCancel}
                          autoFocus
                        >
                          Annuler
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginRight: '30px', marginBottom: "40px" }}
                          onClick={handleSubmit}
                          autoFocus
                        >
                          Enregistrer
                        </Button>

                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Box>
            )
          }

        </Paper>

      </MainContainer>
    </React.Fragment>
  );
}

export default VehicleAdd;